import {
  WorkSessionAccumulatedDTO,
  WorkSessionCategoryDTO,
  WorkSessionDTO,
  WorkSessionPayloadDTO,
} from "./dtos";
import { httpClient } from "core/api/http/httpClient";

import {
  StopwatchAvailabilityDTO,
  WorkSession,
  WorkSessionCategory,
} from "../model";
import { mapWorkSession } from "../model/work-session.mapper";

const baseRoute = "/work_sessions";

export const workSessionService = {
  create: async (payload: WorkSessionPayloadDTO): Promise<WorkSession> => {
    const dto = await httpClient.post<WorkSessionDTO>(baseRoute, payload);
    return mapWorkSession(dto);
  },

  createStopwatch: async (
    payload: WorkSessionPayloadDTO,
  ): Promise<WorkSession> => {
    const dto = await httpClient.post<WorkSessionDTO>(
      `${baseRoute}/stopwatch`,
      payload,
    );
    return mapWorkSession(dto);
  },

  getStopwatchAvailability: async (): Promise<StopwatchAvailabilityDTO> => {
    return httpClient.get<StopwatchAvailabilityDTO>(
      `${baseRoute}/stopwatch/availability`,
    );
  },

  getAll: async (): Promise<WorkSession[]> => {
    const dtos = await httpClient.get<WorkSessionDTO[]>(baseRoute);
    return dtos.map(mapWorkSession);
  },

  updateById: async (
    id: number,
    payload: Partial<WorkSessionPayloadDTO>,
  ): Promise<WorkSession> => {
    const dto = await httpClient.patch<WorkSessionDTO>(
      `${baseRoute}/id/${id}`,
      payload,
    );
    return mapWorkSession(dto);
  },

  deleteById: (id: number) => httpClient.delete<void>(`${baseRoute}/id/${id}`),

  getAccumulated: (params: any) =>
    httpClient.get<WorkSessionAccumulatedDTO>(`${baseRoute}/accumulated`, {
      params,
    }),

  getWorkSessionsCategory: async (): Promise<WorkSessionCategory[]> => {
    const dtos = await httpClient.get<WorkSessionCategoryDTO[]>(
      `${baseRoute}/category`,
    );

    return dtos.map((c) => ({
      id: c.id,
      name: c.name,
    }));
  },
};
